<template>
    <div class="error_text">
        <label class="lavel_error_font text_white_space_pre_wrap">{{validationMessage}}</label><br>
    </div>
</template>

<script>
    export default {
        name: 'Message',
        props: {
            validationMessage: {
                type: String,
                required: true,
            }
        }
    }
</script>
